module.exports = __webpack_public_path__ + "img/ressoarte06.2219b134.jpg";